import script from "./ServiceListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceListView.vue?vue&type=script&setup=true&lang=js"

import "./ServiceListView.vue?vue&type=style&index=0&id=5fc8524c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fc8524c"]])

export default __exports__